import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Favicon = () => {
  const isDukes = (): boolean => {
    const params = new URLSearchParams(window.location.search);
    const paramValue = params.get('customerId');
    return paramValue === '01H0QF3X9D0ER9MW94AQ58DHBT';
  };
  const isBwt = (): boolean => {
    const params = new URLSearchParams(window.location.search);
    const paramValue = params.get('customerId');
    const bwtCustomerIds = ['01HJ6AEK80MDH91H69CDNEKQEE', '01HZFRQDBQ253N53HG94272G7W'];
    if (paramValue) {
      if (bwtCustomerIds.includes(paramValue)) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  };
  const location = useLocation();
  useEffect(() => {
    let faviconPath = '/favicon/favicon-32x32.png';
    if (isDukes()) {
      faviconPath = '/favicon/favicon-dukes.png';
    } else if (isBwt() === true) {
      faviconPath = '/favicon/favicon-bwt.png';
    }

    const updateFavicon = () => {
      const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
      if (favicon) {
        favicon.href = faviconPath;
      } else {
        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.href = faviconPath;
        document.head.appendChild(newFavicon);
      }
    };

    updateFavicon();
  }, [location]);

  return null;
};

export default Favicon;
